export function resetHeightChannelOverview() {
    const sections = Array.from(document.querySelectorAll('.channel-wrapper .row'));

    const resetHeightForElements = (sections: Element[], selector: string) => {
        sections.forEach(section => {
            const dynamic = Array.from(section.querySelectorAll(`.item ${selector}`));

            dynamic.forEach(element => {
                const closestItem = (element as HTMLElement).closest('.item');
                (element as HTMLElement).style.height = 'auto';
            });

            let maxHeight = 0;
            dynamic.forEach(element => {
                const closestItem = (element as HTMLElement).closest('.item');
                const paragraphHeight = (element as HTMLElement).offsetHeight;
                maxHeight = Math.max(maxHeight, paragraphHeight);
            });

            dynamic.forEach(element => {
                const closestItem = (element as HTMLElement).closest('.item');
                (element as HTMLElement).style.height = `${maxHeight}px`;
            });
        });
    };

    resetHeightForElements(sections, '.channel-content');
}